import classNames from 'classnames';
import React from 'react';
import './Topics.scss';

interface TopicsProps {
  title: string;
  data: { Name: string; Url: string }[];
  noBackground?: boolean;
}

export const Topics = ({ title, data, noBackground }: TopicsProps) => {
  return (
    <div
      className={classNames('l-section-padding', 'news-topics', {
        'news-topics--no-background': noBackground,
      })}
    >
      <h2 className='news-topics-heading'>{title}</h2>
      <div className='news-topics-tabs'>
        {data.map(({ Name, Url }, index) => (
          <a key={index} href={Url} className='news-topics-tab font-medium-sm-lh-140'>
            {Name}
          </a>
        ))}
      </div>
    </div>
  );
};
